import React from "react";
import { OTHER_OPTION_VALUE } from "../utils/excelFieldOptions";

function DropdownWithOther({
  label,
  id,
  options = [],
  selectValue = "",
  otherValue = "",
  onSelectChange,
  onOtherChange,
  placeholder = "Select an option",
  otherPlaceholder = "Enter other value",
  otherInputType = "text",
  otherMultiline = false,
  otherRows = 3,
  disabled = false,
  selectClassName = "w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100",
  otherClassName = "w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100",
  labelClassName = "text-sm font-medium text-slate-700",
}) {
  const OtherInput = otherMultiline ? "textarea" : "input";

  return (
    <div className="flex flex-col gap-1.5">
      {label ? (
        <label htmlFor={id} className={labelClassName}>
          {label}
        </label>
      ) : null}
      <select
        id={id}
        value={selectValue}
        onChange={(e) => onSelectChange(e.target.value)}
        disabled={disabled}
        className={`${selectClassName} disabled:bg-slate-50 disabled:text-slate-400`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
        <option value={OTHER_OPTION_VALUE}>Other</option>
      </select>
      {selectValue === OTHER_OPTION_VALUE ? (
        <OtherInput
          type={otherMultiline ? undefined : otherInputType}
          rows={otherMultiline ? otherRows : undefined}
          value={otherValue}
          onChange={(e) => onOtherChange(e.target.value)}
          placeholder={otherPlaceholder}
          disabled={disabled}
          className={otherClassName}
        />
      ) : null}
    </div>
  );
}

export default DropdownWithOther;
